import * as React from "react";
import SEO from "../components/seo";
import Layout from "../components/layout";
import SimpleHero from "../components/v2/simple-hero";
import HeadlineBanner from "../components/v2/headline-banner";
import FiftyFiftyHorizontal from "../components/v2/fifty-fifty-horizontal";
import ImageComparison from "../components/v2/image-comparison";
import GetUpdates from "../components/v2/get-updates";
import DetailsFooter from "../components/v2/details-footer";

// Hooks
import useMarketHallPageImages from "../hooks/useMarketHallPageImages";

const MarketHall = () => {
  return (
    <Layout
      className="template-details"
      bodyTheme="light"
      isFooter={false}
      headerLayout="mobile"
    >
      <SEO title="The Market Hall" />
      <SimpleHero
        contentData={
          {
            pre_title: "The",
            title: "Market Hall",
          }
        }
        imageData={useMarketHallPageImages({name: "market-hall-1"})}
      />
      <HeadlineBanner
        className="spacing spacing--general"
        pre_title="A Rising"
        title="Tide"
      />
      <FiftyFiftyHorizontal
        imageData={useMarketHallPageImages({name: "market-hall-4"})}
      >
        <p>Market Hall will be home to a collection of shops that we invite you to explore when you visit Campus Salt Lake. These are some of the most interesting, innovative, and downright cool businesses we’ve had the pleasure of working with. And each one will add something special to the Campus Salt Lake experience. Check back soon for more details about the shops you’ll find in Market Hall.</p>
      </FiftyFiftyHorizontal>
      <ImageComparison
        className="spacing spacing--general"
        itemOneImageData={useMarketHallPageImages({name: "market-hall-3"})}
        itemTwoImageData={useMarketHallPageImages({name: "market-hall-2"})}
      />
      <GetUpdates className="spacing spacing--general" />
      <DetailsFooter
        imageData={useMarketHallPageImages({name: "market-hall-5"})}
        imageDataHover={useMarketHallPageImages({name: "market-hall-6"})}
        linkData={{
          title: "Read Story",
          project_url: "/the-art/",
        }}
        pre_title="Up Next"
        title="The Art"
      />
    </Layout>
  )
}

export default MarketHall
